import SourceEnum from "@common/enums/SourceEnum";
import { Event as HotjarEvent } from "@modules/core/hotjar/types";
import TradeInSourceName from "@modules/trade/enums/TradeInSourceName";
import { AppraisalPageDataPayload } from "@modules/trade/types/AppraisalPageMode";

export type AppraisalSourceEventProperties = {
  hotjarEvent: HotjarEvent;
};

export enum AppraisalMethodEnum {
  InstantCashOffer = "ico",
  ValueEstimate = "value-estimate",
  TradeOrSell = "trade-or-sell",
}

export type AppraisalMethod = `${AppraisalMethodEnum}`;

export type AppraisalSource = {
  id: SourceEnum;
  name: TradeInSourceName | "unknown";
  isKnownSource: boolean;
  allowedSourceOrigins: string[];
  allowedMethods: AppraisalMethod[];
  eventProperties?: AppraisalSourceEventProperties;
};

export type AppraisalData = {
  source: AppraisalSource;
  payload?: AppraisalPageDataPayload;
};
